import { render, staticRenderFns } from "./support_ticket_board.vue?vue&type=template&id=6376c7bc&scoped=true&"
import script from "./support_ticket_board.vue?vue&type=script&lang=js&"
export * from "./support_ticket_board.vue?vue&type=script&lang=js&"
import style0 from "./support_ticket_board.vue?vue&type=style&index=0&id=6376c7bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6376c7bc",
  null
  
)

export default component.exports